<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      <v-divider class="mt-4"></v-divider>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="true">
      <CenterNavbar
        :crumps="[]"
        title="The Incredible Team"
        :width_class="page_info.center_width_class"
      ></CenterNavbar>
      <ContactPageBanner
        :has_nav_bar="true"
        id="team_top"
        bg_class="bg-0"
        :bg_url="bg_url"
      ></ContactPageBanner>

      <template v-for="(team, index) in page_info.teams">
        <CardedSectionHeader :key="index" :label="team.name" :id="'team_'+ team.section_id" >
        </CardedSectionHeader>
        <CardedDisplay :key="'cd-'+index">
          <v-row>
            <v-col cols="8" class="pl-8 text-left font-weight-light text-h6 black--text ">{{team.description}}</v-col>
          </v-row>
          <v-row class="pa-5">
            <v-col
              cols="6"
              v-for="(member, mindex) in team.members"
              :key="mindex"
            >
              <ProfileCard
                :person="member"
              ></ProfileCard>
            </v-col>
          </v-row>
        </CardedDisplay>
        <v-divider :key="'dvd-'+index"></v-divider>
      </template>

      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>
    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>


<script>
import Page from "./../../components/Page";

import SidePageColumn from "./../../components/SidePageColumn";
import QuickSideLinks from "./../../components/QuickSideLinks";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";

import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterNavbar from "./../../components/CenterNavbar";
import ContactPageBanner from "./../../components/ContactPageBanner";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CardedDisplay from "./../../components/CardedDisplay";
import ProfileCard from "./../../components/ProfileCard";
import Footer from "./../../components/CenterFooter";

import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";

import page_info from "./../../lib/page_info";
import ServerClient from "./../../lib/ServerClient";

export default {
  name: "Team",
  components: {
    Page,

    SidePageColumn,
    QuickSideLinks,
    FeaturedSidePromotions,

    CenterPageColumn,
    CenterNavbar,
    ContactPageBanner,
    CardedSectionHeader,
    CardedDisplay,
    ProfileCard,
    Footer,

    SelfPromoAdd,
    HomeSideAdsContainer,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      page: "team",
      bg_url:
        "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601570320/botswana%20services/website%20assets/kanye_court_nqjdln.png",
      page_info: page_info,
    };
  },
  computed:{
    quick_links(){
      var ql = [];
      for (let index = 0; index < page_info.teams.length; index++) {
        const team = page_info.teams[index];
        ql.push({
          text: team.name,
          href: "#team_" + team.section_id,
        });
      }
      return ql;
    }
  },
  mounted() {
    var options = {
      offset: 102,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#team_top", options);
  },
};
</script>